import React, { useEffect, useState } from "react";
import MultiProductCard from "./MultiProductCard";
import Typewriter from "../../CommonComponents/TypeWriting";
import { useSelector, useDispatch } from "react-redux";
import { isStreamingStarted, loader } from "../../Services/Redux/Reducers/commonSlice";
import { isStream } from "../../Services/Redux/Reducers/chatSlice";
import { filterOutfitVideoLoader, getTitle } from "../../Services/CommonServices/helper";
import { MCatProductCardProps } from "../../Services/CommonServices/propTypes";
import { cloneDeep } from "lodash";
 
const MultiCatTemplate = (props) => {
  const [products, setProducts] = useState([]);
  const [cardLength, setCardLength] = useState();
  const [isOverviewTextLoading, setIsOverviewTextLoading] = useState(false);
  const [isProductLoading, setIsProductLoading] = useState(false);
  const [isMobileHeader, setIsMobileHeader] = useState(true);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.common.isLoader);
  const streamingState = useSelector((state) => state.chat.isStream);
  const conList = useSelector((state) => state.chat.conversationList);
  const isStopTriggered = useSelector((state) => state.chat.isStopButtonTriggered)
  const [updateIndex, setUpdateIndex] = useState(0); // To track updates

  useEffect(() => {
    if(props.effects && props.index === conList?.length-1 && loading && !isStopTriggered){
      let convoList = cloneDeep(conList);
      let lastItem = convoList?.pop();
      setProducts(filterOutfitVideoLoader(lastItem?.question))
    } else {
      const result = products?.filter(item => !item.loader);
      setProducts(result)
    }
  }, [props.effects, props.index, isStopTriggered])

  useEffect(() => {
    if (window.innerWidth > 576) {
      setIsMobileHeader(false);
    } else {
      setIsMobileHeader(true);
    }
  }, [window.innerWidth]);

  useEffect(() => {
    if(((props.index === conList?.length-1 && loading) && (props.backgroundImage || props.text || props.conclusion))) {
      dispatch(isStreamingStarted(false));
    }
    if (props.index === conList?.length-1 && !isStopTriggered && props.isAnswerComplete && loading) {
      if ((props.text != null && isOverviewTextLoading === true && ((props.products && isProductLoading) || props.products === undefined || props.products === null))) {
        // dispatch(storeChat(true));
        dispatch(loader(false));
        const result = products?.filter(item => !item.loader);
        setProducts(result)
      }
    }
    if (
      !isStopTriggered &&
      !isOverviewTextLoading &&
      !isProductLoading &&
      streamingState
    ) {
      // dispatch(storeChat(true));
      dispatch(loader(true));
    }
  }, [
    props.isAnswerComplete,
    props.products,
    props.text,
    isOverviewTextLoading,
    loading,
    isProductLoading,
  ]);

  useEffect(() => {
    if(props?.products?.length > 0) {
      if((props.index === conList?.length-1 && loading)) {
        setCardLength(props?.products?.length)
        setProducts((prevMergedArray) => {
          const updatedArray = [...prevMergedArray]; // Copy of current merged array
          updatedArray[updateIndex] = props.products[updateIndex]; // Replace image with data
          return updatedArray;
        });

        setUpdateIndex((prevIndex) => {
          const nextIndex = prevIndex + 1; // Increment the index
          return nextIndex < props?.products?.length ? nextIndex : prevIndex; // Ensure within bounds
        });
      } else {
        setCardLength(props?.products?.length)
        setProducts(props.products)
      }      
    }
  }, [props.products, updateIndex])

  const categoryListing = (products) => {
    if (products) {
      let data = {
        text: "Show me details for the " + getTitle(products) + " look.", //as per Peter's comments
        query: "Can you show me details of outfit with ID " + products.id + "?",
        type: props.responseType,
        lookTitle: getTitle(products),
      };
      if (!props.stopClick) {
        props?.onValueChange(data);
      }
      dispatch(isStream(true));
    }
  };

  return (
    <div className="multicat_template">
      <div className="row productdetails-div">
        <div className="col-11 col-lg-8">
          {
            props.text && (
              <div className="mcat-text response_bg">
                <Typewriter
                  convoId={props.convoId}
                  type="responseText"
                  responseType={props.responseType}
                  text={props.text}
                  delay={props.delay}
                  isAnswerComplete={props.isAnswerComplete}
                  setLoading={setIsOverviewTextLoading}
                  effects={props.effects}
                  propertyKey={"responseText"}
                />
              </div>
            )
          }
        </div>
      </div>
      {
        isOverviewTextLoading && products?.length > 0 &&
        <div className={`container p-0 multicat-header`}>
            <div>
              <div className={`${!isMobileHeader && "d-none"}`}>
                <img
                  src={props.backgroundImage}
                  alt="headerImg"
                  className="imgHeader"
                />
              </div>
              <div className={`${isMobileHeader && "d-none"}`}>
                <img
                  src={props.desktopbackgroundImage}
                  alt="headerImg"
                  className="imgHeader"
                />
              </div>
            </div>
          
            <div className="col-12 d-flex flex-column" style={{marginTop:"160px"}}>
              <div className="cards p-0 d-flex" style={{overflowY: "hidden"}}>
                {products &&
                  products.map((productDetails, productIndex) => (
                    <MultiProductCard
                      index={props.index}
                      categoryListing={() => {
                        categoryListing(productDetails, productIndex);
                      }}
                      key={productIndex}
                      product={productDetails}
                      products={products}
                      productIndex={productIndex}
                      cardLength={cardLength}
                      convoId={props.convoId}
                      isAnswerComplete={props.isAnswerComplete}
                      setIsProductLoading={setIsProductLoading}
                      effects={props.effects}
                      delay={props.delay}
                      stopClick={props.stopClick}
                    />
                  ))}
                <div className="multioutfit-spacing" style={{minWidth:"7px"}}></div>
              </div>
            </div>
        </div>
      }
    </div>
  );
};

MultiCatTemplate.propTypes = MCatProductCardProps;

export default MultiCatTemplate;
